module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-superiority-cn.946a12f4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-superiority-cn.png
// module id = 2829
// module chunks = 11